import { Component } from '@angular/core';

@Component({
  selector: 'app-notes',
  imports: [],
  templateUrl: './notes.html',
})
export class Notes {

}
